import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSettings } from '../../context/SettingsContext';

export default function AboutPage() {
  const { settings } = useSettings();
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    axios.get('/api/employees').then(r => setEmployees(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <div className="page-hero">
        <h1>About Us</h1>
        <p>{settings.about_headline}</p>
      </div>

      {/* Story */}
      <section className="section" style={{ background: '#fff' }}>
        <div className="container">
          <div style={{ maxWidth: 760, margin: '0 auto' }}>
            <h2 className="section-title">Our Story</h2>
            <div className="gold-divider" />
            <p style={{ fontSize: 16, color: '#444', lineHeight: 1.85, whiteSpace: 'pre-line' }}>
              {settings.about_body}
            </p>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section" style={{ background: '#f8f7f2' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h2 className="section-title">Meet the Team</h2>
            <div className="gold-divider gold-divider-center" />
            <p className="section-sub">The people who make {settings.store_name} what it is</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 24 }}>
            {employees.length === 0 ? (
              <div style={{ gridColumn: '1/-1', textAlign: 'center', color: '#9a9a9a', padding: '40px 0' }}>
                Team profiles coming soon.
              </div>
            ) : employees.map(emp => (
              <div key={emp.id} className="card" style={{ padding: 28, textAlign: 'center' }}>
                <div style={{ width: 100, height: 100, borderRadius: '50%', overflow: 'hidden', margin: '0 auto 16px', background: '#e8e8e8', border: '3px solid #c9a227' }}>
                  {emp.photo_url ? (
                    <img src={emp.photo_url} alt={emp.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, color: '#9a9a9a' }}>👤</div>
                  )}
                </div>
                <h3 style={{ fontSize: 17, fontWeight: 800, color: '#1a2744', marginBottom: 4 }}>{emp.name}</h3>
                <p style={{ fontSize: 13, color: '#c9a227', fontWeight: 700, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{emp.title}</p>
                {emp.bio ? (
                  <p style={{ fontSize: 14, color: '#555', lineHeight: 1.7 }}>{emp.bio}</p>
                ) : (
                  <p style={{ fontSize: 13, color: '#bbb', fontStyle: 'italic' }}>Bio coming soon</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section" style={{ background: '#1a2744', color: '#fff' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h2 style={{ fontSize: 28, fontWeight: 800, color: '#fff', marginBottom: 8 }}>What We Stand For</h2>
            <div className="gold-divider gold-divider-center" />
          </div>
          <div className="grid-3" style={{ gap: 32 }}>
            {[
              ['⚖️', 'Fair Dealings', 'We offer competitive prices on everything we buy and sell. No lowball offers, no hidden fees.'],
              ['🤝', 'Community First', "Natchitoches is our home. We reinvest in this community and treat every customer like a neighbor."],
              ['🔒', 'Legal & Compliant', 'As an FFL dealer, we follow all federal and state regulations for every firearm transaction — no exceptions.'],
            ].map(([icon, title, desc]) => (
              <div key={title} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 40, marginBottom: 14 }}>{icon}</div>
                <h3 style={{ fontSize: 18, fontWeight: 700, color: '#c9a227', marginBottom: 10 }}>{title}</h3>
                <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)', lineHeight: 1.7 }}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
